var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-side-nav",class:[_vm.mobile ? 'mobile ' + _vm.brandName : 'list-group ' + _vm.brandName]},_vm._l((_vm.filteredLinks()),function(link){return _c('router-link',{key:link.id,class:{
			active: ("/" + _vm.activeRouteName) === link.href,
			'u-side-nav__logout': link.name === 'global.logOut',
			'list-group-item list-group-item-action': !_vm.mobile
		},attrs:{"to":link.href,"aria-current":"true"}},[_c('Icon',{attrs:{"icon":link.icon}}),_c('span',[_vm._v(_vm._s(_vm.$t(link.name)))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }